// extracted by mini-css-extract-plugin
export var caption = "caption-module--caption--4lv8s";